/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { store } from "../lib/store";
import React from "react";
import { Provider } from "react-redux";
function ReduxProvider(param) {
    let { children } = param;
    return /*#__PURE__*/ _jsx(Provider, {
        store: store,
        children: children
    });
}
export default ReduxProvider;
